import axios from "axios";

export default class Country {
  constructor() {
    this.base_url = process.env.REACT_APP_URL_PERSON;
    this.name = "/paises";
    this.url = this.base_url + this.name;
  }

  grid = async (skip = 0, take = 100, active) => {
    return await axios.get(
      `${this.url}?skip=${skip}&take=${take}&active=${active}`
    );
  };

  changeActive = async (id) => {
    await axios.patch(`${this.url}/${id}`);
  };
}
